import * as React from 'react';
import {Button, Typography, Tooltip, IconButton, Box} from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import {CopyAll} from "@mui/icons-material";

interface ReviewLineLinkProps {
    shortLink: string;
}

const ReviewLineLink = (props: ReviewLineLinkProps) => {
    const { shortLink } = props;

    const [hint, setHint] = React.useState<string>('Copy link');

    /**
     * Копирование в буфер обмена
     */
    const copyLink = () => {
        const text = document.querySelector('#textLink')?.innerHTML;
        navigator.clipboard.writeText(`${text}`);
        setHint(`Скопированно: ${text}`);
    }

    return (
        <>
            <Typography
                id="textLink"
                sx={{
                    fontSize: { xs: 10, md: 40 },
                    cursor: 'pointer',
                    // border: '1px solid #3914af',
                    borderBottom: '1px solid',
                    color: '#3914af',
                    width: '100%',
                    paddingLeft: 2,
                    overflow: 'auto'
                }}
                onClick={copyLink}
            >
                {shortLink}
            </Typography>
            <Tooltip title={hint} placement="top">
                <IconButton onClick={copyLink} style={{color: 'black'}}>
                    <CopyAll/>
                </IconButton>
            </Tooltip>

        </>
    )
}

export default ReviewLineLink;